import { render, staticRenderFns } from "./contractDetail copy.vue?vue&type=template&id=75caa838&"
import script from "./contractDetail copy.vue?vue&type=script&lang=js&"
export * from "./contractDetail copy.vue?vue&type=script&lang=js&"
import style0 from "./contractDetail copy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports